/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box, Tooltip, Typography} from '@mui/material';
import {LucideIcon} from 'lucide-react';

interface ResourceItem {
  name?: string;
  title?: string;
  question?: string;
  filename?: string;
}

interface ResourceCountItemProps {
  icon: LucideIcon;
  count: number;
  items: ResourceItem[] | null;
  color: string;
  singularLabel: string;
  pluralLabel: string;
  tooltipTitle: string;
}

export const ResourceCountItem = ({
  icon: IconComponent,
  count,
  items = [],
  color,
  singularLabel,
  pluralLabel,
  tooltipTitle,
}: ResourceCountItemProps) => {
  // Ensure items is always an array
  const itemsArray = items || [];

  return (
    <Tooltip
      title={
        <Box component={'span'} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          <Typography variant={'body2'} fontWeight={'bold'} mb={0.5}>
            {tooltipTitle}:
          </Typography>
          {itemsArray.map((item, index) => (
            <Typography key={index} variant={'body2'}>
              {item.name || item.title || item.question || item.filename || `${singularLabel} ${index + 1}`}
            </Typography>
          ))}
        </Box>
      }
      PopperProps={{
        onClick: (e) => e.stopPropagation(),
      }}
    >
      <Typography variant={'body2'} sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
        <Box sx={{color}}>
          <IconComponent size={16} />
        </Box>
        <Typography component={'span'} fontWeight={'medium'} color={color}>
          {count}
        </Typography>
        {count === 1 ? ` ${singularLabel}` : ` ${pluralLabel}`}
      </Typography>
    </Tooltip>
  );
};
